export default function (nga, admin, activities) {

    var parent_categories = admin.getEntity('parent_categories');

    var categories = admin.getEntity('categories');
    categories.listView()
        .title('{{ "Categories" | translate }}')
        .fields([
            nga.field('name')
              .isDetailLink(true),
            nga.field('activity_id', 'reference')
                .targetEntity(activities)
                .targetField(nga.field('name'))
                .sortable(false)
                .label('Activity'),
            nga.field('parent_id', 'reference')
                .targetEntity(categories)
                .targetField(nga.field('name'))
                .sortable(false)
                .label('Parent category')
        ])
        .filters([
            nga.field('activity_id', 'reference')
                .targetEntity(activities)
                .targetField(nga.field('name'))
                .label('Activity'),
            nga.field('parent_id', 'reference')
                .targetEntity(parent_categories)
                .targetField(nga.field('name'))
                .label('Parent category'),
            nga.field('q', 'template')
                .label('')
                .pinned(true)
                .template('<div class="input-group"><input type="text" ng-model="value" class="form-control"></input><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>')
        ])
        .actions(['create', 'filter'])
        .listActions([
            '<ma-filtered-list-button entity-name="exercises" filter="{ category_id: entry.values.id }" size="xs"></ma-filtered-list-button>',
            'edit'
        ]);
    categories.creationView()
        .fields([
            nga.field('name')
                .validation({ required: true }),
            nga.field('activity_id', 'reference')
                .targetEntity(activities)
                .targetField(nga.field('name'))
                .label('Activity')
                .editable(false)
                .validation({ required: true }),
            nga.field('parent_id', 'reference')
                .targetEntity(categories)
                .targetField(nga.field('name'))
                .label('Parent category'),
            nga.field('', 'template')
                .label('')
                .editable(false)
                .template('<span class="pull-right"><ma-filtered-list-button entity-name="exercises" filter="{ category_id: entry.values.id }" size="sm"></ma-filtered-list-button></span>')

        ]);
    categories.editionView()
        .title('{{ "EDIT" | translate }}')
        .fields(categories.creationView().fields());

    return categories;
}



// WEBPACK FOOTER //
// ./js/categories/config.js